import { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { api, formatApiError } from "../../lib/api";
import { NETWORKS } from "../../lib/share";

/** Editor de título, descripción y textos por red social de un material. */
export const CaptionEditor = ({ material, onClose, onSaved }) => {
  const [form, setForm] = useState({ title: material.title, description: material.description || "", captions: { ...material.captions } });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch(`/admin/marketing/materials/${material.slug}`, form);
      toast.success("Textos guardados: toda la red los verá al compartir");
      onSaved(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-2xl overflow-y-auto rounded-[1.5rem]" data-testid="caption-editor">
        <DialogHeader>
          <DialogTitle className="font-display">Textos listos por red social</DialogTitle>
          <DialogDescription>Lo que el distribuidor verá precargado al compartir. Al final se agrega automáticamente su enlace personal.</DialogDescription>
        </DialogHeader>
        <Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="bg-paper" data-testid="caption-title" />
        <Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Descripción" className="bg-paper" data-testid="caption-description" />
        {NETWORKS.map(({ id, label, Icon, color }) => (
          <label key={id} className="block">
            <span className="mb-1 flex items-center gap-1.5 text-xs font-semibold"><Icon className="h-3.5 w-3.5" style={{ color }} /> {label}</span>
            <Textarea rows={3} value={form.captions[id] || ""} onChange={(e) => setForm({ ...form, captions: { ...form.captions, [id]: e.target.value } })} className="bg-paper text-sm" data-testid={`caption-${id}`} />
          </label>
        ))}
        <button type="button" onClick={save} disabled={busy} className="btn-ink !px-5 !py-2.5 !text-xs disabled:opacity-60" data-testid="caption-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Guardar</button>
      </DialogContent>
    </Dialog>
  );
};
